import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Subject, BehaviorSubject } from "rxjs";
// import { NgxSpinnerService } from 'ngx-spinner';

// const cacheBuster$ = new Subject<void>();

@Injectable({
  providedIn: "root",
})
export class ApiServiceService {
  private dataSource = new BehaviorSubject("");
  currentMessage = this.dataSource.asObservable();

  base_url = environment.baseUrl;

  httpOptions = {
    headers: new HttpHeaders({ "Content-Type": "application/json" }),
    // withCredentials: true
  };

  constructor(
    private http: HttpClient // private loaderService: NgxSpinnerService
  ) {}

  getRequest(url: string, param = {}) {
    const httpOptions = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
      params: param,
      // withCredentials: false
    };
    return this.http.get(`${this.base_url}/` + url, httpOptions);
  }

  postRequest(url, request_data) {
    return this.http.post(
      `${this.base_url}/` + url,
      request_data,
      this.httpOptions
    );
  }

  deleteRequest(url) {
    return this.http.delete(`${this.base_url}/` + url, this.httpOptions);
  }

  uploadRequest(url, form_data) {
    return this.http.post(`${this.base_url}/` + url, form_data);
  }

  putRequest(url, form_data) {
    return this.http.put(`${this.base_url}/` + url, form_data);
  }
}
